<template>
    <section class="contact-section">
        <div class="contact-row">
            <!-- Izquierda: título y descripción -->
            <div class="contact-header">
                <h2 class="contact-title">Contáctanos</h2>
                <p class="contact-desc">
                    Nuestro equipo está listo para ayudarte. Comunícate por medio de
                    <strong>WhatsApp</strong> para recibir soporte o cotizaciones
                    personalizadas.
                </p>
            </div>

            <!-- Derecha: card WhatsApp -->
            <div class="contact-card">
                <div class="wa-icon-wrap">
                    <i class="fab fa-whatsapp wa-icon"></i>
                </div>
                <p class="card-label">Chatea con nosotros</p>
                <a href="https://wa.me/50222927882" target="_blank" class="wa-btn">
                    <i class="fab fa-whatsapp"></i>
                    Iniciar conversación
                </a>
            </div>
        </div>
    </section>
</template>

<style scoped>
.contact-section {
    background-color: transparent;
    padding: 56px 24px 64px;
}

.contact-row {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 2rem;
    max-width: 900px;
    margin: 0 auto;
    text-align: center;
}

@media (min-width: 992px) {
    .contact-row {
        flex-direction: row;
        align-items: center;
        text-align: left;
    }

    .contact-header {
        flex: 1 1 0;
    }
}

.contact-title {
    font-size: 28px;
    font-weight: 700;
    color: #1a1a1a;
    margin-bottom: 10px;
}

.contact-desc {
    font-size: 14px;
    color: #6c757d;
    line-height: 1.6;
    max-width: 420px;
    margin: 0 auto;
}

@media (min-width: 992px) {
    .contact-desc {
        margin: 0;
    }
}

.contact-desc strong {
    color: #1a8a3e;
    font-weight: 600;
}

/* Card */
.contact-card {
    background: #fff;
    border-radius: 14px;
    padding: 32px 40px;
    flex-shrink: 0;
    width: 100%;
    max-width: 340px;
    box-shadow: 0 2px 16px rgba(0, 0, 0, 0.07);
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 14px;
}

.wa-icon-wrap {
    display: flex;
    justify-content: center;
}

.wa-icon {
    font-size: 56px;
    color: #25d366;
    line-height: 1;
}

.card-label {
    font-size: 15px;
    font-weight: 600;
    color: #1a1a1a;
    margin: 0;
}

.wa-btn {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    background-color: #2e7d32;
    color: #fff;
    font-size: 14px;
    font-weight: 600;
    padding: 11px 24px;
    border-radius: 50px;
    text-decoration: none;
    transition: background-color 0.2s ease, transform 0.15s ease;
}

.wa-btn:hover {
    background-color: #1b5e20;
    transform: translateY(-1px);
}

@media (max-width: 480px) {
    .contact-card {
        padding: 28px 20px;
    }
}
</style>
